<template>
    <CompassFormItem
        :label="localizedTexts.date"
        orientation="horizontal"
        size="small"
        class="panel-create-activity__form-date"
    >
        <CompassDatePicker
            :value="dateInput"
            :calendarOptions="{ lang: uiLang, disableWeekDays: disabledWeekDays }"
            datePickerClass="panel-create-activity__datepicker"
            :formatDateDisplayed="formatDateDisplayed"
            writable
            class="input-select-date-activity"
            @update:value="onUpdateDateInput"
        />
        <CompassTimePicker
            v-model="timeInput"
            :hourFormat="hourformat"
            class="input-time-activity"
            :min="workingTimeStart"
            :max="workingTimeEnd"
            autoScroll
            @update:value="updateTimeInput"
        />
    </CompassFormItem>
</template>

<script>
import ActivityFormPanelDate from 'vcomponents/activities/activitiesFormPanel/ActivityFormPanelDate.vue';

export default {
    extends: ActivityFormPanelDate,
    data() {
        return {
            dateInput: '',
            timeInput: '',
        };
    },
    created() {
        if (this.activityData) {
            this.dateInput = moment(this.activityData.due_date).format('YYYY-MM-DD');
            this.timeInput = moment(this.activityData.due_date).format('HH:mm');
        } else {
            this.timeInput = moment(this.workingHours.end_time, 'HH:mm').format('HH:mm');
            this.dateInput = moment().isAfter(moment(this.workingHours.end_time, 'HH:mm'))
                ? this.getNextWorkingDay()
                : moment().format('YYYY-MM-DD');
        }
        this.updateDate();
    },
    methods: {
        onUpdateDateInput(value) {
            this.dateInput = value;
            this.updateDate();
        },
        updateDate() {
            const timeMoment = moment(this.timeInput, 'HH:mm');

            const date = moment(this.dateInput);
            date.set('hours', timeMoment.hours());
            date.set('minutes', timeMoment.minutes());

            this.$emit('update:activityDate', {
                due_date: date.toISOString(true),
            });
        },
        updateTimeInput(value) {
            this.timeInput = value;
            this.updateDate();
        },
    },
};
</script>

<style scoped lang="scss">
.panel-create-activity__form-date::v-deep {
    .compass-form-item__input {
        flex-direction: row;
        gap: var(--spacing-3);
        .input-time-activity {
            width: 100px;
        }
        .input-select-date-activity .compass-input {
            min-width: 120px;
            width: 120px;
        }
    }
}
</style>
